<!--  -->
<template>
  <div class="container">
    <div class="item one">
      <span class="hint">企业名称</span>
      <span class="hint_info">{{companyInfo.company_name}}</span>
    </div>
    <div class="item">
      <span class="hint">统一社会信用代码</span>
      <span class="hint_info">{{companyInfo.company_code}}</span>
    </div>
    <div class="item">
      <span class="hint">邮箱地址</span>
      <span class="hint_info">{{companyInfo.email}}</span>
    </div>
    <div class="item one orther">
      <div class="hint-one">营业执照</div>
      <div class="camera">
        <img :src="'https://www.jspx0769.com'+companyInfo.business_license" alt />
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      companyInfo:{},//企业信息
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 获取企业信息
    getCompanyInfo(){
      this.$http.getUserInfo({}).then(res=>{
        if(res.status == 1){
          this.companyInfo = res.data
        }else{
          this.$hide.alert({
            message:res.msg
          })
        }
      })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getCompanyInfo()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: #f5f5f5;
  .one {
    margin-top: 8px;
  }
  .item {
    width: 100%;
    height: 44px;
    padding: 0 18px;
    box-sizing: border-box;
    background-color: #fff;
    line-height: 44px;
    border-bottom: 1px solid #e5e5e5;
    .hint {
      float: left;
      font-size: 16px;
      color: #333333;
    }
    .hint_info {
      float: right;
      font-size: 16px;
      color: #666666;
    }
    .hint-one {
      color: #666666;
      width: 100%;
      font-size: 15px;
      margin: 0;
      padding: 0;
    }
    .camera {
      width: 76px;
      height: 76px;
      background-color: #fff;
      position: relative;
      margin-bottom: 10px;
      margin-top: 10px;
      border: 1px solid #EAEAEA;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 76px;
        height: 53px;
      }
    }
  }
  .orther{
      height: auto;
  }
}
</style>